import Block from '../block'

export default class Tabs extends Block {
    static title = 'tabs'

    init() {
        this.tabElements = this.getElements('tab')
        this.tabElements.forEach(tabElement => {
            tabElement.addEventListener('click', () => this.openTab(tabElement.dataset.tabId))
        })

        this.contentElements = this.getElements('content')

        this.tabSlug()
    }

    tabSlug() {
        const target = location.hash
        const tabsWithSlug = Array.from(this.getElements('tab')).filter(tab => tab.dataset.slug)

        if (target !== '') {
            const tab = tabsWithSlug.find(tab => tab.dataset.slug === target)

            if (tab) {
                this.openTab(tab.dataset.tabId)
            }
        }

        tabsWithSlug.forEach(tab => {
            tab.addEventListener('click', () => {
                location.hash = tab.dataset.slug
            })
        })
    }

    openTab(tabId) {
        this.tabElements.forEach(tabElement => {
            if (tabElement.dataset.tabId === tabId) {
                tabElement.classList.add('tabs__tab--active')
                return
            }

            tabElement.classList.remove('tabs__tab--active')
        })

        this.contentElements.forEach(contentElement => {
            if (contentElement.dataset.tabId === tabId) {
                contentElement.classList.add('tabs__content--active')
                return
            }

            contentElement.classList.remove('tabs__content--active')
        })
    }
}